import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import { ParamsAndReturnTypes } from '@prisjakt/ui-translate/src/translate-func';
import StockStatus from '@prisjakt/ui-stock-status';
import PriceNotice from '@prisjakt/ui-price-notice';
import Tooltip from '@prisjakt/ui-tooltip-new';

import * as S from './styles';

type OwnProps = {
  className?: string;
  status?: string;
  statusText?: string;
  toneDown?: boolean;
  countryCode?: string;
  isInternationalPrice?: boolean;
  showTooltip?: boolean;
  priceType?: string;
  showInternational?: boolean;
};

const StockStatusColumn = ({
  className,
  status,
  statusText,
  toneDown = false,
  countryCode,
  isInternationalPrice = false,
  showTooltip = true,
  priceType,
  showInternational = false,
}: OwnProps) => {
  const { t } = useContext(AppContext);
  const processedStatusText = statusText
    ? statusText.replace(/-/g, '\u2011') /* no-breaking hyphen in dates */
    : t(
        'product',
        `stock-status.${status ||
          'unknown'}` as keyof ParamsAndReturnTypes['product']
      );

  return (
    <>
      {priceType !== undefined && priceType !== 'normal' ? (
        <S.PriceNoticeWrapper hideText>
          <Tooltip
            placement="left"
            title={t(
              'product',
              `price-notice.${priceType}` as keyof ParamsAndReturnTypes['product']
            )}
          >
            <PriceNotice
              type={priceType}
              textAtBottom={false}
              centerAlign={false}
              toneDown
            />
          </Tooltip>
        </S.PriceNoticeWrapper>
      ) : null}
      {countryCode && (
        <S.CountryFlag
          show={isInternationalPrice}
          countryCode={countryCode}
          tooltip={
            showTooltip
              ? t(
                  'common',
                  `market.${countryCode}` as keyof ParamsAndReturnTypes['common']
                )
              : ''
          }
        />
      )}
      <S.StockStatusWrapper
        toneDown={toneDown}
        alignCenter={!showInternational}
        className={className}
      >
        <StockStatus
          classicIcons
          status={status}
          showText={false}
          toneDown={toneDown}
          tooltip={showTooltip ? (processedStatusText as string) : ''}
        />
      </S.StockStatusWrapper>
    </>
  );
};

const { string, bool } = PropTypes;

StockStatusColumn.propTypes = {
  className: string,
  status: string,
  statusText: string,
  toneDown: bool,
  countryCode: string,
  isInternationalPrice: bool,
  showInternational: bool,
  showTooltip: bool,
  priceType: string,
};

StockStatusColumn.defaultProps = {
  className: undefined,
  status: undefined,
  statusText: undefined,
  toneDown: false,
  countryCode: null,
  isInternationalPrice: false,
  showInternational: false,
  showTooltip: true,
  priceType: undefined,
};

export default memo(StockStatusColumn);
